export default {
      id: "watch-induction-video-usage",
      viewBox: "0 0 36 31",
      url: __webpack_public_path__ + "sprite.svg#watch-induction-video",
      toString: function () {
        return this.url;
      }
    }